///////////////////////////////////////////////////////////////////////////////
// Filename : module-switcher.component.ts
// Description : Module switcher to switch between modules
// Revision History:
// Version  | Date        |  Change Description
// ---------------------------------------------
// 1.0      | 01-Jul-2019 |  Single Unit First Production Release
// 2.0      | 31-Jul-2019 |  Single Unit Second Production Release
// 3.0      | 01-Nov-2019 |  Multi Unit Production Release
// 4.0      | 06-Jan-2020 |  Release for Copyright
// Copyright : Detect Technologies Pvt Ltd.
///////////////////////////////////////////////////////////////////////////////

import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common/common.service';
declare var $: any;

import { DataService } from '../../services/data.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-module-switcher',
  templateUrl: './module-switcher.component.html',
  styleUrls: ['./module-switcher.component.scss']
})
export class ModuleSwitcherComponent implements OnInit {

  headerLogo: string ;
  modules: any[] = [];
  selectedModule: string ;
 
  @HostListener('document:click', ['$event']) handleMouseEvent(event: any) {
    if (event.target.id != 'moduleSwitcher' && event.target.id != 'moduleSwitcherIcon') {
      this.closeMenu();
    }
  }

  constructor(private commonService: CommonService, private router: Router, private dataService: DataService, private snackbarService: SnackbarService) { }

  ngOnInit() {
    this.selectedModule = sessionStorage.getItem("lastname");
    this.commonService.readConfigurationsData().subscribe(data => {
      this.headerLogo = data['blackDetectLogo'];
      this.modules = data['modules'];
      this.fetchSelectedModule();
      this.router.events.subscribe((routerData: any) => {
        this.fetchSelectedModule();
      });
    });
    if(this.selectedModule == null){
    this.navigate('module','/software-configuration')
    sessionStorage.setItem("lastname", "/software-configuration");
    }
  }

  fetchSelectedModule() {
    let url = window.location.pathname;
    let selectedModule: any = this.modules.filter(module => module.routeUrl.split('/')[1] === url.split('/')[1]);
    selectedModule = (selectedModule.length > 0) ? selectedModule[0].moduleName : '';
    this.selectedModule = (url.split('/').length > 0) ? selectedModule : ''; 
  }
  
  navigate(type, routeUrl) {
    if (type === 'module') {
      this.router.navigateByUrl(routeUrl);
      window.location.assign(routeUrl)
    }
    else {
      this.dataService.passSpinnerFlag(true, true);
      this.commonService.navigateToModule(routeUrl);
      this.dataService.passSpinnerFlag(false, true)
    }
  }

  openMenu() {
    $('#mySidenav').css('width', '270px');
  }

  closeMenu() {
    $('#mySidenav').css('width', 0);
  }
}
